import { render, staticRenderFns } from "./ReportNotificationModal.vue?vue&type=template&id=97e2c81c&"
import script from "./ReportNotificationModal.vue?vue&type=script&lang=js&"
export * from "./ReportNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./ReportNotificationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports